import React from 'react';
import PropTypes from 'prop-types';
import classes from './deleteCard.module.scss';
import Button from '../../../../_common/Form/Buttons/Button';
import Modal from '../../../../_common/Modal/Modal';

const DeleteCardModal = ({
  isOpen, onClose, onDeleteClick, loading,
}) => (
  <Modal
    open={!!isOpen}
    onClose={onClose}
  >
    <div className={classes.wrapper}>
      <h2>Are You sure you want to remove selected items from Card?</h2>

      <div className={classes.button_wrapper}>
        <Button
          title="Cancel"
          clearButton
          className={classes.btn}
          onClick={onClose}
        />

        <Button
          title="Delete"
          buttonColor="red"
          className={classes.btn}
          onClick={onDeleteClick}
          loading={loading}
        />
      </div>
    </div>
  </Modal>
);

DeleteCardModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
};

export default DeleteCardModal;
